var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3438 7.09375H7.90625V4.65625C7.90625 4.432 7.72425 4.25 7.5 4.25C7.27575 4.25 7.09375 4.432 7.09375 4.65625V7.09375H4.65625C4.432 7.09375 4.25 7.27575 4.25 7.5C4.25 7.72425 4.432 7.90625 4.65625 7.90625H7.09375V10.3438C7.09375 10.568 7.27575 10.75 7.5 10.75C7.72425 10.75 7.90625 10.568 7.90625 10.3438V7.90625H10.3438C10.568 7.90625 10.75 7.72425 10.75 7.5C10.75 7.27575 10.568 7.09375 10.3438 7.09375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0625 7.50003C1.0625 11.0481 3.94755 13.9503 7.5 13.9503C11.0524 13.9503 13.9375 11.0481 13.9375 7.50003C13.9375 3.94975 11.0503 1.0625 7.5 1.0625C3.94973 1.0625 1.0625 3.94974 1.0625 7.50003Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plusIcon.ec0cd31df325fc968b4dc45a6a447fcd.svg";
export { ForwardRef as ReactComponent };